/* eslint-disable */
(function($){
    const App = {
        sugerMobMenu() {
            $("#mobile-bars").sidr({
              name: "sidr",
              side: "left",
              speed: 400,
              displace: false,
              timing: "ease",
              onOpen() {
                $("#mobile-bars i").removeClass("fa-bars").addClass("fa-times");
                $("body").css({
                  position: "fixed",
                  width: "100%",
                  background: "rgba(0, 0, 0, 0.5)",
                });
                $("#sidr").css('display', 'block');
              },
              onClose() {
                $("#mobile-bars i").removeClass("fa-times").addClass("fa-bars");
                $("body").css({
                  position: "static",
                  width: "auto",
                  background: "transparent",
                });
                
              },
            });
            $('#sidr').css('display', 'block');
            $(document).on("click", function (e) {
              if (!$(e.target).closest("#sidr").length) {
                  $.sidr( 'close', 'sidr' );
              }
            });
      
            /*sidr sub menu*/
            const sidrParentMenu = $("#sidr #mobile-view li.menu-item-has-children");
            const sidrSubmenu = $("#sidr #mobile-view ul.sub-menu");
            const parentAncor = $(
              "#sidr #mobile-view li.menu-item-has-children"
            ).children("a");
      
            $('<i class="fa-solid fa-chevron-down"></i>').appendTo(parentAncor);
            sidrSubmenu.hide();
            sidrParentMenu.children("a").on("click", function (e) {
              e.preventDefault();
              $(this).next("ul.sub-menu").stop().slideToggle();
              $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
            });
            $('ul#mobile-view li.menu-item-has-children a').css({'display': 'flex', 'justify-content' : 'space-between', 'align-items' : 'center'});
            
          },
          sugerVenobox(){
            
            let venoBox = new VenoBox({
              selector: '.image-popup',
              bgcolor: '#3C92CA',
              numeration: true,
              spinner: 'wandering-cubes'
            });
            
          },
          stickyHeader(){
            let navBarHeight = document.getElementById('masthead');
            let bodyElement = document.body;
            let adminBarElement = document.getElementById('wpadminbar');
            let navbar = document.getElementById('masthead');
            let headerSpacing = document.getElementById('header-spacing');
            let lastScrollTop = 0;
            
            headerSpacing.style.height = `${navBarHeight.offsetHeight}px`;
            if(bodyElement.classList.contains('logged-in')){
              headerSpacing.style.height = `${navBarHeight.offsetHeight - adminBarElement.offsetHeight}px`;
            }
            navbar.style.top = "0";
            window.addEventListener("scroll", function(){
              let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              if(scrollTop === 0){
                  navbar.classList.remove('sticky-header');
              } else{
                  navbar.classList.add('sticky-header');
              }
              if(scrollTop > lastScrollTop){
                navbar.style.top = `-${navBarHeight.offsetHeight}px`;
              } else{
                navbar.style.top = "0";
              }
              lastScrollTop = scrollTop;
            })
          },
          sugerSlider(){
            let swiper = new Swiper(".suger-slider-nav", {
                spaceBetween: 10,
                slidesPerView: 3,
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                threshold: 5
              });
            let swiper2 = new Swiper(".suger-slider", {
                spaceBetween: 10,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                thumbs: {
                  swiper: swiper,
                },
              });
        },
          
    }

    App.init = function(){
        App.sugerMobMenu();
        App.sugerVenobox();
        App.sugerSlider();
        // App.stickyHeader();
    }
    $(function(){
        App.init();
        
    });
})(jQuery);